import { useQuery } from "@tanstack/react-query";
import { omit } from "lodash";
import { accountsKeys } from "PFCore/hooks/queries/accounts/query_keys";
import { fetchAccount, fetchNotificationSettings } from "PFCore/services/accounts/account";
import {
  EditAccountForm,
  FormNotificationSettings
} from "PFModules/saas_admin/accounts/edit/edit_account.types";
import { DEFAULT_FORM_VALUES } from "PFModules/saas_admin/accounts/edit/edit_account.utils";
import { QueryOptions } from "PFTypes/request_options";

export const useAccountFormData = (
  accountId: number | undefined,
  options?: QueryOptions<EditAccountForm>
) => {
  const isEditMode = !!accountId;
  return useQuery<EditAccountForm>(
    accountsKeys.account(accountId),
    () => {
      if (isEditMode) {
        return fetchAccount(accountId).then((accountData) => {
          const accountFormValues = omit(accountData, "id");
          const form: EditAccountForm = {
            ...DEFAULT_FORM_VALUES,
            ...accountFormValues,
            notificationSettings: accountFormValues.notificationSettings as FormNotificationSettings,
            owner: {
              ...accountFormValues.owner,
              password: "",
              passwordConfirmation: ""
            }
          };
          return form;
        });
      } else {
        return fetchNotificationSettings().then((notificationData) => ({
          ...DEFAULT_FORM_VALUES,
          notificationSettings: notificationData as FormNotificationSettings
        }));
      }
    },
    options
  );
};
